import React, { useState, useRef } from 'react';
import useStyles from './styles';
import { Select, MenuItem } from '@mui/material';
import { get } from 'global/lib/lodash';
import sendData from 'redux/actions/sendData';
import SnackAlerts from 'global/components/snack-alerts';
import { Loading } from 'global/styles';
import clsx from 'clsx';
import { useView } from '../../../global/hooks/useView';
import { Checkbox } from 'global/components/checkbox';
import { UserSelectModal } from 'global/components/userselectmodal';

export default (props) => {
  const classes = useStyles();
  const { assessment, userCanEdit, isTemplate } = props;
  const [loading, setLoading] = useState();
  const [alerts, setAlerts] = useState();
  const [options] = useState([
    { title: 'Draft', value: 'draft' },
    { title: 'Review', value: 'review' },
    { title: 'Final', value: 'published' },
  ]);
  const usref = useRef();

  const { view, setView } = useView();

  const currentStatus = get(assessment, 'data.status');
  const sendReceipt = !!get(view, 'sendReceipt');

  const onChange = async (e) => {
    try {
      const value = e.target.value;
      const id = get(assessment, 'data.id');
      setLoading(true);

      let notify_users;
      if (value !== 'draft' && sendReceipt) {
        const { assignedTo } = await get(usref, 'current.displayModal', () => 0)();
        notify_users = assignedTo.map((u) => u.id);
      }

      await sendData({
        url: `/assessments/${id}`,
        method: 'patch',
        data: {
          data: {
            id,
            type: 'assessments',
            attributes: {
              status: value,
              notify_users,
            },
          },
        },
      });

      if (!!notify_users) {
        setAlerts({ message: 'Email sent', severity: 'success' });
      }

      await Promise.all([
        assessment.update(),
        get(props, 'scores.update', () => 0)()
      ])
    } catch (err) {
      setAlerts({ message: `Unable to change status: ${err.message}`, severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  if (isTemplate) {
    const isGlobal = currentStatus === 'global_template';
    const text = {
      t1: isGlobal ? 'THIS IS A <i>GLOBAL</i> TEMPLATE ASSESSMENT' : 'THIS IS A TEMPLATE ASSESSMENT',
      t2: isGlobal ? `It can be copied by all users in your organization with access to "${get(assessment, 'data.realm.name')}"` : `It's only visible to the author and users set as "Editors"`,
    };
    return (
      <div className={clsx(classes.container, classes.containerTemplate)}>
        {loading && <span style={{ marginRight: 5 }}>{Loading}</span>}

        <div className={classes.templateTextContainer}>
          <b dangerouslySetInnerHTML={{ __html: text.t1 }} />
          <div dangerouslySetInnerHTML={{ __html: text.t2 }} />
        </div>

        <SnackAlerts alerts={alerts} setAlerts={setAlerts} />
      </div>
    );
  }

  if (currentStatus === 'published' || !userCanEdit) {
    return null;
  }

  const assignees = [...get(assessment, 'data.editors', []), ...get(assessment, 'data.viewers', []), ...get(assessment, 'data.assignees', [])];

  return (
    <div className={classes.container}>
      {loading && <span style={{ marginRight: 5 }}>{Loading}</span>}
      <span>Status:</span>

      <Select value={currentStatus} variant="filled" defaultValue="N/A" className={classes.select} disableUnderline onChange={onChange}>
        {options.map((opt, i) => {
          return (
            <MenuItem key={i} value={get(opt, 'value')}>
              {opt.title}
            </MenuItem>
          );
        })}
      </Select>

      <Checkbox label={'Send Receipt'} checked={sendReceipt} onChange={() => setView('sendReceipt', !sendReceipt)} />

      <SnackAlerts alerts={alerts} setAlerts={setAlerts} />

      <UserSelectModal ref={usref} assignees={assignees} realm_id={get(assessment, 'data.realmId')} />
    </div>
  );
};
